<nz-alert
  *ngIf="(definition?.references | format : toDefinitions) > 0 || includeVal"
  [nzMessage]="messageTemplate"
  nzType="info"></nz-alert>
<ng-template #messageTemplate>
  <span *ngIf="includeVal">
    <strong (click)="insertAtCursor()">val</strong> - {{ 'mdm.obs-def-02.intervals.value' | translate }}
  </span>

  <div *ngFor="let def of definition?.references | format : toDefinitions" class="reference-line">
    <span *ngIf="def.code !== definition?.code">
      <strong (click)="insertAtCursor(def.code)">refs["{{ def.code }}"]</strong> -
      {{ def | format : formatReferenceLine }}
    </span>

    <span class="reference-selects">
      <hw-term-codesystem-concept-select
        *ngIf="def.dataType?.code === 'code-system'"
        [(ngModel)]="rangeHints[def.code]"
        (ngModelChange)="addValue($event, def.code)"
        [ngModelOptions]="{ standalone: true }"
        display="codeName"
        [codesystem]="def.dataOptions['codesystem']"></hw-term-codesystem-concept-select>
      <hw-select
        *ngIf="def.dataType?.code === 'select'"
        [(ngModel)]="rangeHints[def.code]"
        (ngModelChange)="addValue($event, def.code)"
        [ngModelOptions]="{ standalone: true }">
        <hw-option
          *ngFor="let option of def.dataOptions['values']"
          [label]="option.names | localName"
          [value]="option.value"></hw-option>
      </hw-select>
    </span>
  </div>
</ng-template>

<textarea
  #textArea
  nz-input
  [name]="name"
  [ngModel]="input"
  (ngModelChange)="inputChange.emit($event)"
  nzAutosize
  required></textarea>
